<template>
  <div class="simple-search-table-container">

    <div>
      <el-form :model="queryParams" inline size="mini">
        <el-form-item label="品牌">
          <el-input v-model="queryParams.brand_name" placeholder="品牌名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="销售">
          <el-input v-model="queryParams.last_sale_name" placeholder="销售" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="default-table"
         v-loading="loading"
         element-loading-text="合作品牌加载中……"
         element-loading-spinner="el-icon-loading">
      <el-table :data="dataList" @sort-change="changeTableSort" border>
        <el-table-column type="index" label="序号" width="100" align="center"></el-table-column>
        <!--        <el-table-column prop="id" label="ID" width="100" align="center" sortable="custom"></el-table-column>-->
        <el-table-column prop="brand_name" label="品牌名称" min-width="260" align="center"
                         sortable="custom"></el-table-column>
        <el-table-column prop="last_sale_name" label="最近合作销售" min-width="200" align="center"
                         sortable="custom"></el-table-column>
        <el-table-column prop="last_co_at" label="最近合作日期" min-width="160" align="center"
                         sortable="custom">
          <template slot-scope="{row}">
            <span>{{ $utils.parseTime(row.last_co_at, '{y}年{m}月{d}日') }}</span>
          </template>
        </el-table-column>
        <!--        <el-table-column prop="co_customer_num" label="合作次数" min-width="140" align="center" sortable="custom"></el-table-column>-->
        <!--        <el-table-column prop="sales_volume" label="累计销量" min-width="140" align="center" sortable="custom"></el-table-column>-->
        <!--        <el-table-column prop="created_at" label="创建时间" min-width="140" align="center" sortable="custom"></el-table-column>-->
        <!--        <el-table-column prop="updated_at" label="更新时间" min-width="140" align="center" sortable="custom"></el-table-column>-->
      </el-table>
      <div class="page-footer">
        <pagination :total.sync="total" :page.sync="pageData.current_page" :limit.sync="pageData.page_size"
                    @pagination="getList">
        </pagination>
      </div>

    </div>
  </div>
</template>

<script>
import {getBrandRecordList} from "@/api/customerPool";

export default {
  name: "BrandRecord",
  data() {
    return {
      total: 0,
      pageData: {current_page: 1, page_size: 15},
      orderBy: {brand_name: 'asc'},
      queryParams: {last_sale_name: null, brand_name: null}
      , dataList: []
      , loading: false
    }
  },
  methods: {
    changeTableSort({prop, order}) {
      let orderSort = {}
      if (order) {
        orderSort[prop] = order === 'descending' ? 'desc' : 'asc'
      }
      this.orderBy = orderSort
      // this.orderBy = `\`${prop}\` ${order === 'descending' ? 'desc' : 'asc'}`
      this.getList()
    },
    async getList() {
      this.loading = true
      this.dataList = []
      let queryParams = this.handleSearchCondition(this.queryParams, this.pageData, this.orderBy)
      let {list, pages} = await getBrandRecordList(queryParams).then((res) => {
        return res.model || {}
      })
      this.loading = false
      this.dataList = list || []
      this.total = pages.total || 0
      this.pageData.current_page = pages.current_page || 1
    },
    handleSearchCondition(searchCondition, pageData, orderBy) {
      let condition = {}
      Object.keys(searchCondition).forEach((field) => {
        if (searchCondition[field]) {
          condition[field] = searchCondition[field]
        }
      })

      // 分页 +排序
      Object.assign(condition, pageData, {orderBy: orderBy})

      return condition
    },
    handleQuery() {
      this.getList()
    }
  },
  created() {
    this.handleQuery()
  }
}
</script>

<style scoped>
.page {
  height: 100vh;
  width: 100vw;
  background-color: #fe346e;
}
</style>
